import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CircleAdmiration } from '../../assets/icons/CircleAdmiration.svg';
import { ReactComponent as HandWaving } from '../../assets/icons/HandWaving.svg';
import Button from '../Buttons/Button/Button';
import Context from '../../store/context';
import { paths } from '../../routes';
import YesNoQuestion from '../modals/YesNoQuestion/YesNoQuestion';

import classes from './PageCarousel.module.scss';

const PageCarousel = ({pages = 0, page = 0}) => {

  const circles = () => {
    const listPages = []
    for (let index = 0; index < pages; index++) {
      listPages.push(<div key={`carousel-${index}`} className={ page === index ? classes['circle-active']:classes['circle-inactive'] }></div>)
    }
    return listPages;
  }

  return (
    <div className={classes.content}>
      { circles() }
    </div>
  );
};

export default PageCarousel;
